/**
 * Route for `guided-onboarding`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GuidedOnboardingPage } from "../features/guided-onboarding/GuidedOnboardingPage";

export const guidedOnboardingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/guided-onboarding",
	component: GuidedOnboardingPage,
});

export default guidedOnboardingRoute;
